import React from 'react';
import { ContactForm } from '../../contact';
import { Banner, SEO } from '../../common';
import { Layout } from '../../layout';

export default function Contact() {
  return (
    <Layout>
      <SEO title="Contacto" />
      <Banner text={<>Contáctenos</>} />
      <ContactForm />
    </Layout>
  );
}
